"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoucherCodeRedemptionResponseSchema = exports.RedeemVoucherCodeBodySchema = exports.RedeemVoucherCodeQuerySchema = exports.UpdateVoucherCodeBodySchema = exports.CreateVoucherCodeBodySchema = exports.ListVoucherCodesResponseSchema = exports.ListVoucherCodesQuerySchema = exports.VoucherCodeResponseSchema = exports.UpdateVoucherDefinitionBodySchema = exports.CreateVoucherDefinitionBodySchema = exports.ListVoucherDefinitionsResponseSchema = exports.ListVoucherDefinitionsQuerySchema = exports.VoucherDefinitionResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const VoucherPayloadSchema = typebox_1.Type.Optional((0, core_1.JSONObject)({}, {
    title: "Voucher payload",
    description: "Contains details of the given voucher.",
}));
exports.VoucherDefinitionResponseSchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    type: ruby_1.VoucherTypeSchema,
    minSpend: core_1.MoneySchema,
    maxDiscount: core_1.MoneySchema,
    payload: VoucherPayloadSchema,
    ...core_1.ModelMetaFields,
});
exports.ListVoucherDefinitionsQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    ...core_1.DateFilterFields,
    type: typebox_1.Type.Optional(ruby_1.VoucherTypeSchema),
});
exports.ListVoucherDefinitionsResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.VoucherDefinitionResponseSchema);
exports.CreateVoucherDefinitionBodySchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    type: ruby_1.VoucherTypeSchema,
    minSpend: core_1.MoneySchema,
    maxDiscount: core_1.MoneySchema,
    payload: VoucherPayloadSchema,
});
exports.UpdateVoucherDefinitionBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(core_1.NameSchema),
    type: typebox_1.Type.Optional(ruby_1.VoucherTypeSchema),
    minSpend: typebox_1.Type.Optional(core_1.MoneySchema),
    maxDiscount: typebox_1.Type.Optional(core_1.MoneySchema),
    payload: typebox_1.Type.Optional(VoucherPayloadSchema),
});
exports.VoucherCodeResponseSchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
    code: ruby_1.VoucherCodeSchema,
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    status: ruby_1.VoucherCodeStatusSchema,
    ...core_1.ModelMetaFields,
});
exports.ListVoucherCodesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    teamId: typebox_1.Type.Optional(core_1.IdSchema),
});
exports.ListVoucherCodesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.VoucherCodeResponseSchema);
exports.CreateVoucherCodeBodySchema = (0, core_1.StrictObject)({
    teamId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    start: core_1.TimestampSchema,
    end: core_1.TimestampSchema,
    status: ruby_1.VoucherCodeStatusSchema,
    definitionId: core_1.IdSchema,
});
exports.UpdateVoucherCodeBodySchema = (0, core_1.StrictObject)({
    teamId: (0, core_1.OptionalNullable)(core_1.IdSchema),
    start: typebox_1.Type.Optional(core_1.TimestampSchema),
    end: typebox_1.Type.Optional(core_1.TimestampSchema),
    status: typebox_1.Type.Optional(ruby_1.VoucherCodeStatusSchema),
});
exports.RedeemVoucherCodeQuerySchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    code: ruby_1.VoucherCodeSchema,
});
exports.RedeemVoucherCodeBodySchema = (0, core_1.StrictObject)({
    code: ruby_1.VoucherCodeSchema,
});
exports.VoucherCodeRedemptionResponseSchema = (0, core_1.StrictObject)({
    redeemed: typebox_1.Type.Boolean({}),
    reason: core_1.DescriptionSchema,
});
